var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.manageImage(_vm.src),"lazy-src":_vm.manageImage(_vm.thumbnail),"alt":"avatar","aspect-ratio":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }